<template>
  <div>
    <SubTitle text="Sectores a planificar">
      <span class="options">
        <el-checkbox v-model="pinnedAll"
                     :indeterminate="isIndeterminate"
                     @change="changePinned"
                     :disabled="sectors.length < 1"
                     class="pinned-all">
          <i class="fas fa-map-pin"/>Fijar todos en mapa
        </el-checkbox>
        <!--el-button size="small"
                   class="default"
                   :loading="!allLoaded"
                   @click="add">NUEVO SECTOR</el-button-->
        <el-dropdown trigger="click"
                     @command="addSector">
          <el-button size="small"
                     class="default">
            CREAR SECTOR POR<i class="el-icon-arrow-down el-icon--right"/>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="LOCALIDAD"
                              icon="fas fa-map-marker-alt">Localidad</el-dropdown-item>
            <el-dropdown-item command="POLÍGONO"
                              icon="fas fa-draw-polygon">Polígono</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </span>
    </SubTitle>
    <div class="card-section">
      <p v-if="sectors.length < 1" class="msg-not-sector">NINGUN SECTOR CREADO AÚN</p>
      <div v-else
           class="container-sectors">
        <SectorItem v-for="(sector, index) in sectors"
                    :key="sector.id"
                    :index="index"
                    :data="configuration"
                    v-model="sectors[index]"
                    @editing="editing"
                    :editingMode="editingStatus"
                    @remove="remove(index, sector.color)"/>
      </div>
    </div>
  </div>
</template>

<script>
import SectorItem from './Item.vue';
import SubTitle from '../../base/SubTitle.vue';
import { cachedAPIRequest } from '../../../../mixins/cacheDim';

export default {
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    newCount: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  name: 'SectorList',
  components: {
    SubTitle,
    SectorItem,
  },
  data() {
    return {
      editingStatus: false,
      countSector: 0,
      pinnedAll: true,
      configuration: {
        regionList: [],
        localityList: [],
        enterpriseList: [],
        packageTypeList: [],
      },
      colors: [
        '#ef5fdd',
        '#982bc5',
        '#8b5aff',
        '#3c51da',
        '#00e8b1',
        '#10d0e8',
        '#009688',
        '#ff9a9a',
        '#f3d900',
        '#deae00',
        '#ff9e0f',
        '#ab3a04',
        '#ff4c4c',
        '#795548',
        '#ff6500',
        '#607d8b',
        '#ca7b4c',
      ],
      colorsAvailable: [],
    };
  },
  mounted() {
    this.refreshColor();
    this.getRegionList();
    this.getLocalityList();
    this.getEnterpriseList();
    this.getPackageTypeList();
  },
  watch: {
    value() {
      this.pinnedAll = this.value.filter(s => s.pinned).length > 0;
    },
    newCount() {
      // TODO: reasignación de colores en caso de no venir en un orden
      this.statusByConfiguration();
    },
    sectors() {
      this.$emit('input', this.sectors);
    },
    colorsAvailable() {
      if (this.colorsAvailable.length === 0) { this.refreshColor(); }
    },
  },
  methods: {
    addSector(mode) {
      this.countSector = this.countSector + 1;
      const sector = {
        mode,
        enterprise: {},
        vehicles: [],
        suborders: [],
        packageTypes: [],
        pinned: true,
        maximumPrice: 0,
        currentPrice: 0,
        maximumVolume: 0,
        currentVolume: 0,
        id: this.countSector,
        color: this.getColor(1),
        name: `nuevo sector ${this.countSector}`,
      };
      if (mode === 'LOCALIDAD') {
        sector.region = {};
        sector.localities = [];
      } else {
        sector.polygon = [];
        sector.region = {};
        sector.localities = [];
      }
      this.sectors.push(sector);
    },
    editing(status) {
      this.editingStatus = status;
    },
    add() {
      this.countSector = this.countSector + 1;
      this.sectors.push({
        region: {},
        enterprise: {},
        vehicles: [],
        suborders: [],
        localities: [],
        packageTypes: [],
        pinned: true,
        maximumPrice: 0,
        currentPrice: 0,
        maximumVolume: 0,
        currentVolume: 0,
        id: this.countSector,
        color: this.getColor(1),
        name: `nuevo sector ${this.countSector}`,
      });
    },
    remove(id, color) {
      this.sectors.splice(id, 1);
      this.$notify({
        type: 'success',
        title: 'Sector Eliminado',
      });
      if (!this.colorsAvailable.includes(color)) { this.colorsAvailable.push(color); }
    },
    getRegionList() {
      cachedAPIRequest({
        module: 'planning',
        service: 'regions',
        params: { limit: 1000 },
      }).then((data) => {
        this.configuration.regionList = data.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar las regiones',
        });
      });
    },
    getLocalityList() {
      cachedAPIRequest({
        module: 'crud',
        service: 'get_localities',
        params: { limit: 2500 },
      }).then((data) => {
        this.configuration.localityList = data.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar las localidades',
        });
      });
    },
    getPackageTypeList() {
      cachedAPIRequest({
        module: 'planning',
        service: 'package_types',
        params: { limit: 1000 },
      }).then((data) => {
        this.configuration.packageTypeList = data.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar los tamaños',
        });
      });
    },
    getEnterpriseList() {
      cachedAPIRequest({
        module: 'planning',
        service: 'enterprises',
        params: { limit: 6000 },
      }).then((data) => {
        this.configuration.enterpriseList = data.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar las empresas',
        });
      });
    },
    getColor(count) {
      return this.colorsAvailable.splice(0, count)[0];
    },
    refreshColor() {
      this.colorsAvailable = this.colors.slice();
    },
    getErrors() {
      const err = [];
      const countExistSoc = this.value.filter(s => s.suborders.length > 0).length;
      const countMissingData = this.value
        .filter(s => s.name === ''
          || !s.enterprise.id
          || s.vehicles.length < 1
          || s.packageTypes.length < 1
          || (s.mode === 'POLÍGONO' && s.polygon.length === 0)
          || (s.mode === 'LOCALIDAD' && (!s.region.id || s.localities.length < 1))).length;
      if (this.value.length < 1) err.push('No se ha creado ningún sector');
      else {
        if (countMissingData > 0) err.push('Hay sectores con datos faltantes');
        if (countExistSoc < 1) err.push('Ningun sector tiene socs asociados');
      }
      this.$emit('errors', err);
    },
    changePinned(status) {
      // eslint-disable-next-line no-return-assign,no-param-reassign
      this.value.forEach(s => s.pinned = status);
    },
    verifiedPinned() {
      this.pinnedAll = this.value.filter(s => s.pinned).length === this.value.length;
    },
    statusByConfiguration() {
      this.refreshColor();
      this.countSector = this.newCount;
      this.value.forEach((s) => {
        // eslint-disable-next-line no-param-reassign
        s.color = this.getColor(1);
      });
    },
  },
  computed: {
    sectors() {
      this.getErrors();
      this.verifiedPinned();
      return this.value;
    },
    isIndeterminate() {
      const pinnedCount = this.value.filter(s => s.pinned).length;
      return pinnedCount > 0 && pinnedCount < this.value.length;
    },
    allLoaded() {
      return Object.entries(this.configuration).every(config => config[1].length > 0);
    },
  },
};
</script>

<style lang="scss" scoped>
  .options {
    float: right;
    .pinned-all {
      margin-right: 14px;
      text-transform: lowercase;
      i {
        margin-right: 8px;
        transform: rotate(30deg);
      }
    }
  }
  .card-section {
    padding: 7px;
    background-color: #fafafa;
    border-radius: 3px;
    box-shadow: inset 0 0 5px 0 rgba(0, 0, 0, 0.1);
    .container-sectors {
      width: 100%;
      display: table;
    }
    .msg-not-sector {
      color: $fb-grey-light-50;
      font-weight: 700;
      text-align: center;
    }
  }
</style>
